import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';

import styles from './UnsupportedMessagePayload.styles.m.css';

interface IUnknownMessageProps {
  text: string;
}

export const UnsupportedMessagePayload: FC<IUnknownMessageProps> = observer(() => {
  const { t } = useTranslation();

  return (
    <TextRenderer
      className={styles.container}
      isPlainText
    >
      {t('message_type_unsupported')}
    </TextRenderer>
  );
});
